import { createContext, useContext } from 'react';

import type { LngLat, Zoom } from '../state/appState';
import type { Bounds } from '../types';

// Read-only live viewport, written by the map on moveend. Separate from
// AppStateContext since it changes on every pan; to MOVE the map, use useMapCommands.
export type Viewport = {
  center: LngLat;
  bounds: Bounds | null; // null until the first moveend writes it
  zoom: Zoom;
};

const ViewportContext = createContext<Viewport | null>(null);

export const ViewportProvider = ViewportContext.Provider;

export const useViewport = (): Viewport => {
  const viewport = useContext(ViewportContext);
  if (viewport === null) {
    throw new Error('useViewport must be used inside <ViewportProvider>');
  }
  return viewport;
};
